module.exports = __webpack_public_path__ + "media/hyper/images/logo-a4cac8bfad608a96c941b75634d88ac3.png";